import axios from 'axios';
import { get } from 'lodash';

export const allReservations = () =>
  axios
    .post('/api/ds-reservation', {
      op: 'list',
      convert: true,
      fullConvert: false,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const allReservationsForUser = (id) =>
  axios
    .post('/api/ds-reservation', {
      op: 'list',
      convert: true,
      fullConvert: false,
      userId: id,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const unreturnedReservations = () =>
  axios
    .post('/api/unreturned-reservations', {
      op: 'list',
      convert: true,
      fullConvert: false,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const archivedReservations = () =>
  axios
    .post('/api/ds-reservation-archive', {
      op: 'list',
      convert: true,
      fullConvert: false,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));
export const archivedReservationsForUser = (id) =>
  axios
    .post('/api/ds-reservation-archive', {
      op: 'list',
      convert: true,
      fullConvert: false,
      userId: id,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const startReservation = (values) =>
  axios
    .post('/api/start-reservation', values)
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const addItemToReservation = (values) =>
  axios
    .post('/api/add-item-to-reservation', values)
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const confirmReservation = (values) =>
  axios
    .post('/api/confirm-reservation', values)
    .then((response) => ({
      data: response.data,
      success: get(response, 'data.success', false),
    }))
    .catch((error) => ({ success: false, data: error.response }));

export const confirmAddItemToReservation = (values) =>
  axios
    .post('/api/confirm-add-item-to-reservation', values)
    .then((response) => ({
      data: response.data,
      success: get(response, 'data.success', false),
    }))
    .catch((error) => ({ success: false }));

export const getReservation = (id, fullConvert = true) =>
  axios
    .post('/api/ds-reservation', {
      op: 'read',
      convert: true,
      fullConvert,
      item: {
        id: id,
      },
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const getArchivedReservation = (id, fullConvert = true) =>
  axios
    .post('/api/ds-reservation-archive', {
      op: 'read',
      convert: true,
      fullConvert,
      item: {
        id: id,
      },
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const deleteReservation = (id) =>
  axios
    .post('/api/ds-reservation', { op: 'delete', item: { id } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const reservationStatusNames = () =>
  axios
    .get('/api/get-reservation-status-names')
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const deleteReservationItem = (id) =>
  axios
    .post('/api/ds-reservation-item', { op: 'delete', item: { id } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const alternativeReservationItem = (reservationId) =>
  axios
    .post('/api/get-alternative-reservation-item', {
      reservationItemId: reservationId,
    })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const confirmAlternativeReservationItem = (data) =>
  axios
    .post('/api/confirm-alternative-reservation-item', data)
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const changeReservationStatus = (data) =>
  axios
    .post('/api/change-reservation-status', data)
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const printDocument = (reservationId, type) =>
  axios
    .post('/api/print-reservation', { reservationId, templateId: type })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const printPdfDocument = (reservationId, type) =>
  axios
    .post('/api/print-pdf-reservation', { reservationId, templateId: type })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const updateReservation = (id, data) =>
  axios
    .post('/api/ds-reservation', {
      op: 'update',
      item: {
        id,
        ...data,
      },
    })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const updateReservationItem = (id, data) =>
  axios
    .post('/api/ds-reservation-item', {
      op: 'update',
      item: {
        id,
        ...data,
      },
    })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const createReservationService = (data) =>
  axios
    .post('/api/ds-reservation-service', { op: 'create', item: data })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const updateReservationService = (data) =>
  axios
    .post('/api/ds-reservation-service', { op: 'update', item: data })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const deleteReservationService = (data) =>
  axios
    .post('/api/ds-reservation-service', { op: 'delete', item: data })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/reservations/_api.js